import { Breadcrumbs } from "@/types/breadcrumbs";
import { ROUTE_NAMES } from "@/constants/routeNames";

const mainPage: Breadcrumbs = {
  path: { name: ROUTE_NAMES.HOME },
  label: "breadcrumbs.main",
};

export const blogPage: Breadcrumbs[] = [
  mainPage,
  {
    path: { name: ROUTE_NAMES.BLOG_LIST },
    label: "breadcrumbs.blog",
  },
];
